import { useState, useContext } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { connect } from "react-redux";

import { PermissionContext } from "../../../hooks/PermissionContext";

import Sidebar from "../../../components/Navigation/Sidebar";
import Topbar from "../../../components/Navigation/Topbar";
import Header from "../../../components/Page/header";

import BankingOrdersTable from "./table";
import { OrderPaymentStatusEnum } from "../../../utils/enumsUtil";

const BankingOrders = ({ reduxDownloadBankingOrders, requestingDownloadOrder }) => {
    const [activeTab, setActiveTab] = useState('pending');
    const [search, setSearch] = useState('');
    
    const { hasPermission } = useContext(
        PermissionContext
    )

    const handleSelectTab = (key) => {
        setActiveTab(key);
    }

    const getTabStatuses = () => {
        const isClient = hasPermission("feature:isClient");

        const statusMap = {
            pending: [OrderPaymentStatusEnum.PENDING],
            processed: [OrderPaymentStatusEnum.AUTHORIZED, OrderPaymentStatusEnum.PAID],
            forManagement: [OrderPaymentStatusEnum.EXPIRED, OrderPaymentStatusEnum.FAILED],
            issues: isClient
                ? [OrderPaymentStatusEnum.CANCELLED, OrderPaymentStatusEnum.COD_CONFIRMED]
                : [
                    OrderPaymentStatusEnum.FAILED,
                    OrderPaymentStatusEnum.CANCELLED,
                    OrderPaymentStatusEnum.COD_CONFIRMED,
                    OrderPaymentStatusEnum.EXPIRED,
                ],
        };

        return statusMap[activeTab];
    }

    const handleDownload = () => {
        if (requestingDownloadOrder) return;
        reduxDownloadBankingOrders({
            status: getTabStatuses(),
            tab: activeTab,
            search,
        });
    }

    const renderTabs = () => {
        // Si el usuario es tipo cliente se renderiza los tab en cuestión
        if (hasPermission("feature:isClient"))
            return (
                <>
                    <Tabs
                        id="banking-orders-tabs"
                        activeKey={activeTab}
                        onSelect={handleSelectTab}
                        className="mb-3"
                        mountOnEnter
                        unmountOnExit
                    >
                        <Tab eventKey="pending" title="Pendiente">
                            {activeTab === 'pending' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.PENDING]} search={search} onSearchChange={setSearch} />
                            )}
                        </Tab>
                        <Tab eventKey="processed" title="Procesada">
                            {activeTab === 'processed' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.AUTHORIZED, OrderPaymentStatusEnum.PAID]} search={search} onSearchChange={setSearch} />
                            )}
                        </Tab>
                        <Tab eventKey="forManagement" title="Pendiente por Gestionar">
                            {activeTab === 'forManagement' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.EXPIRED, OrderPaymentStatusEnum.FAILED]} search={search} onSearchChange={setSearch} />
                            )}
                        </Tab>
                        <Tab eventKey="issues" title="Incidencia">
                            {activeTab === 'issues' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.CANCELLED, OrderPaymentStatusEnum.COD_CONFIRMED]} search={search} onSearchChange={setSearch} />
                            )}
                        </Tab>
                    </Tabs>
                </>
            )

            // Si el usuario no es cliente se renderiza tabs defecto
            return (
                <>
                    <Tabs
                        id="banking-orders-tabs"
                        activeKey={activeTab}
                        onSelect={handleSelectTab}
                        className="mb-3"
                        mountOnEnter
                        unmountOnExit
                    >
                        <Tab eventKey="pending" title="Pendiente">
                            {activeTab === 'pending' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.PENDING]} search={search} onSearchChange={setSearch} />
                            )}
                        </Tab>
                        <Tab eventKey="processed" title="Procesada">
                            {activeTab === 'processed' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.AUTHORIZED, OrderPaymentStatusEnum.PAID]} search={search} onSearchChange={setSearch} />
                            )}
                        </Tab>
                        <Tab eventKey="issues" title="Incidencia">
                            {activeTab === 'issues' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.FAILED, OrderPaymentStatusEnum.CANCELLED, OrderPaymentStatusEnum.COD_CONFIRMED, OrderPaymentStatusEnum.EXPIRED]} search={search} onSearchChange={setSearch} />
                            )}
                        </Tab>
                    </Tabs>
                </>
            )
    }

    return (
        <div>
            <div id='wrapper'>
                <Sidebar />
                <div id='content-wrapper' className='d-flex flex-column'>
                    <div id='content'>
                        <Topbar />
                        <div className='container-fluid'>
                            <Header
                                title={"Órdenes"}
                                subtitle={"Módulo para la gestión de las órdenes creadas con pago eléctronico"}
                                actionButtons={[
                                    {
                                        description: "Descargar Excel",
                                        buttonType: "btn-primary",
                                        buttonIcon: "fa fa-download",
                                        onClick: handleDownload,
                                        disabled: requestingDownloadOrder,
                                        loading: requestingDownloadOrder,
                                    },
                                ]}
                            />
                            <div className='card shadow mb-4'>
                                <div className='card-header py-3'>
                                    {renderTabs()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        requestingDownloadOrder: state.bankingOrdersState.requestingDownloadOrder,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reduxDownloadBankingOrders: (payload) =>
            dispatch({
                type: "DOWNLOAD_BANKING_ORDERS_REQUEST",
                value: payload,
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BankingOrders);